import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NewButton, StyledButton, StyledContainer } from '../../../styles/StyledComponents';
import { Col, Divider, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { TeacherLayout } from '../../layouts/TeacherLayout';
import { UserAvatar } from '../../users/UserAvatar';
import { FormattedMessage } from 'react-intl';

class OrganizationPage extends Component {
  render () {
    const { user = {}, teacher } = this.props;
    return (
      <TeacherLayout user={user} teacher={teacher}>
        <Row gutter={16} justify='center' style={{ width: '100%' }}>
          <Col>
            <Title level={3}>
              <FormattedMessage id="organizations.main.title" />
            </Title>
          </Col>
          <Col flex={1}>
            <NewButton>
              <FormattedMessage id="organizations.main.new-organization-button" />
            </NewButton>
          </Col>
        </Row>
        <br />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={20} xl={10}>
            <StyledContainer style={{ padding: 10 }}>
              <Row gutter={[16, 0]} align='middle'>
                <Col>
                  <UserAvatar src={(teacher && teacher.avatar && teacher.avatar.url) || ''} />
                </Col>
                <Col flex={1}>
                  <strong style={{ fontSize: 16, marginRight: 10 }}>{teacher && teacher.firstName}{' '}{teacher && teacher.lastName}</strong>
                  <small><FormattedMessage id="organizations.main.owner" /></small>
                </Col>
                <Col>
                  <StyledButton style={{ background: '#8053D7', color: '#fff' }}><FormattedMessage id="organizations.main.settings-button" /></StyledButton>
                </Col>
                <Col>
                  <StyledButton style={{ background: 'darkgray', color: '#fff' }}><FormattedMessage id="organizations.main.leave-button" /></StyledButton>
                </Col>
              </Row>
            </StyledContainer>
          </Col>
        </Row>
        <br />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col sm={20} xl={10}>
            <Title level={4}><FormattedMessage id="organizations.main.transformAccounts" /></Title>
            <Divider />
            <Link to='/teacher/organizations/plans'>
              <StyledButton style={{ background: '#8053D7', color: '#fff' }}><FormattedMessage id="organizations.main.turn-tutorB-button" /></StyledButton>
            </Link>
          </Col>
        </Row>
      </TeacherLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    teacher: state.teachers.profile,
    isLoading: state.auth.isLoading
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationPage);
